import React from "react";
import { motion } from "framer-motion";
import { BanIcon, ClockIcon, MoonIcon, FrownIcon } from "lucide-react";
const nodes = [{
  label: "Restricción",
  sub: "Comes una manzana",
  icon: BanIcon,
  pos: "left-1/2 top-0 -translate-x-1/2 -translate-y-1/3 sm:-translate-y-1/2"
}, {
  label: "Ansia",
  sub: "4:00 PM",
  icon: ClockIcon,
  pos: "right-0 top-1/2 -translate-y-1/2 translate-x-[8%] sm:translate-x-1/3"
}, {
  label: "Atracón",
  sub: "8:00 PM, escondida",
  icon: MoonIcon,
  pos: "left-1/2 bottom-0 -translate-x-1/2 translate-y-1/3 sm:translate-y-1/2"
}, {
  label: "Culpa",
  sub: "\"Mañana empiezo\"",
  icon: FrownIcon,
  pos: "left-0 top-1/2 -translate-y-1/2 -translate-x-[8%] sm:-translate-x-1/3"
}];
export function CycleDiagram() {
  return <div className="relative mx-auto aspect-square w-full max-w-[300px] sm:max-w-[380px]" data-id="element-132" data-mp="3bxdbunm2eqsq">
      <motion.svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full" animate={{
      rotate: 360
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: "linear"
    }} aria-hidden data-id="element-133" data-mp="2o7ivvx6g8m49">
        <circle cx="100" cy="100" r="88" fill="none" stroke="#E4B9AB" strokeWidth="2" strokeDasharray="6 6" data-id="element-134" data-mp="2d8gmwnco6pqi" />
        {[45, 135, 225, 315].map(deg => <g key={deg} transform={`rotate(${deg} 100 100)`} data-id="element-135" data-mp="2hzqa7haqxgz8">
            <path d="M100 8 l6 4 -6 4" fill="none" stroke="#C7254E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-136" data-mp="2myt4q7t3o4sy" />
          </g>)}
      </motion.svg>
      <div className="absolute inset-[31%] flex flex-col items-center justify-center rounded-full bg-cocoa text-center text-cream shadow-xl sm:inset-[22%]" data-id="element-137" data-mp="1qadavziyj9a1">
        <p className="font-display text-base font-bold leading-tight sm:text-2xl" data-id="element-138" data-mp="1z7xirrbbs3tm">El ciclo</p>
        <p className="mt-1 hidden px-4 text-xs text-cream/70 sm:block" data-id="element-139" data-mp="248l6o449c4jm">restricción · culpa · ansia</p>
      </div>
      {nodes.map(({
      label,
      sub,
      icon: Icon,
      pos
    }, i) => <motion.div key={label} className={`absolute ${pos} w-[96px] rounded-xl bg-white px-1.5 py-2 text-center shadow-[0_12px_30px_-12px_rgba(59,34,25,0.4)] sm:w-32 sm:rounded-2xl sm:p-3`} initial={{
      opacity: 0,
      scale: 0.96
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      delay: 0.1 + i * 0.12
    }} data-id="element-140" data-mp="3fmfgi3chefqw" data-mpi={i}>
          <Icon className="mx-auto h-4 w-4 text-berry sm:h-5 sm:w-5" data-id="element-141" data-mp="2uyxtxx24tq9z" />
          <p className="mt-1 text-xs font-bold text-cocoa sm:text-sm" data-id="element-142" data-mp="27822j11l8x39">{label}</p>
          <p className="text-[10px] leading-tight text-cocoa-light sm:text-[11px]" data-id="element-143" data-mp="2298qld1y9e57">{sub}</p>
        </motion.div>)}
    </div>;
}